jQuery( document ).ready( function ( $ ) {
	if( $(".block-mp-services" ).length ) {
	
	}
})